export default {"src":"/hedera/_next/static/media/binance.f822d45d.svg","height":14,"width":12};